export const shouldRefreshChatHistory = (messageCount: number) =>
  messageCount > 0 && messageCount <= 2;
